import React, {useRef} from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
import ReplyIcon from '@mui/icons-material/Reply';

import {useOutsideClick} from "../../../../misc/helperHooks";
import {setGroheShareButtonsOpened} from "../../../../actions/groheFunctions";
import {SHARE_BUTTONS} from "../../lookNavigation/lookSideBar/lookSidebarModals/lookSideBarShareButtons";
import GroheShareButton from "./groheShareButton";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";

const GroheShareParentButton = (props) => {

  const {intl, visualizersLoadedLength, topButtonClick, groheShareButtonsOpened, setGroheShareButtonsOpened} = props;

  const selectElement = useRef(null);

  useOutsideClick(selectElement, () => {
    if (groheShareButtonsOpened) {
      setGroheShareButtonsOpened(false);
    }
  });

  const shareButtonsClick = () => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productTopButtonsShare.slice(0, -1));
    if (!visualizersLoadedLength) {
      return false
    }
    topButtonClick();
    setGroheShareButtonsOpened(!groheShareButtonsOpened);
  }

  return (
    <div className={"gm-buttons__button gm-buttons__button--share"} ref={selectElement}>
      <IconButton aria-label={intl.formatMessage({id: "iconButton.share"})}
                  className="look-icon look-icon--small1 look-icon--grohe"
                  onClick={shareButtonsClick}>
        <ReplyIcon style={{transform: "scale(1, -1) rotate(180deg) translateY(-2px)"}}/>
      </IconButton>
      <div className={"gm-share" + (groheShareButtonsOpened ? " gm-share--opened" : "")}>
        {Object.keys(SHARE_BUTTONS).map(buttonKey => <GroheShareButton buttonKey={buttonKey} key={buttonKey}/>)}
      </div>
    </div>
  )
};

GroheShareParentButton.propTypes = {
  topButtonClick: PropTypes.func.isRequired
}

const mapStateToProps = (store) => {
  const {visualizersLoaded} = store.serverState;
  const {groheShareButtonsOpened} = store.groheState;
  return {
    visualizersLoadedLength: visualizersLoaded.length,
    groheShareButtonsOpened,
  };
};

const mapDispatchToProps = {
  setGroheShareButtonsOpened,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheShareParentButton)
)
